import { Box } from 'components/box';
import dynamic from 'next/dynamic';
import { ReactNode } from 'react';

const Modal = dynamic(
  () => import('components/_shared/widgets/modal/with-close')
);

const SocialSharingModal = ({
  close,
  isOpen,
  children,
}: {
  close: () => void;
  isOpen: boolean;
  children: ReactNode;
}) => (
  <Modal
    title="Share this deal with someone!"
    close={close}
    isOpen={isOpen}
    size="small"
  >
    <Box mx={[0, null, 5]}>{children}</Box>
  </Modal>
);

export default SocialSharingModal;
